import {
    GREY3,
    DARK_GREEN,
    SWEGON_GREEN,
    GREY2
} from '@swegon-core/uic/dist/src/theme';
import { styled } from 'styled-components';

export const ContactFormContainer = styled.div`
    width: 30vw;
    height: 100%;
    display: flow;
`;

export const InputFieldContainer = styled.div`
    width: 100%;
    margin-bottom: 1.5em;
    legend {
        font-size: 16px;
        font-weight: bold;
        color: ${GREY3};
        margin-bottom: 8px;
    }
    label {
        color: ${GREY3};
    }
    textarea {
        resize: vertical;
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: end;
`;

export const PrivacyPolicy = styled.div`
    font-size: small;
    font-weight: 300;
    color: ${GREY2};
    margin-top: 1em;
`;

export const PrivacyPolicyLink = styled.a`
    text-decoration: none;

    &:link {
        color: ${SWEGON_GREEN};
    }
    &:visited {
        color: ${DARK_GREEN};
    }
    &:hover {
        text-decoration: underline;
    }
    &:active {
        color: ${DARK_GREEN};
    }
`;
